export default "__VITE_ASSET__DFpQixbw__"